import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatusBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  borderRadius: '15rem',
  color: theme.palette.common.white,
  padding: '0 1rem',
  margin: '0.5rem 0',
  width: 'fit-content',
}));

export default StatusBadge;
